<form [formGroup]="form">
  <label *ngIf="label_block && !hide_label" class="m-0 html-label" [ngClass]="{'req':required}"
    [innerHtml]="label"></label>
  <mat-form-field floatLabel="always" [id]="random_id" [ngClass]="{'no-label':hide_label,'read-only':readonly}">
    <mat-label *ngIf="!label_block&&required" class="req" [innerHtml]="label"></mat-label>
    <mat-label *ngIf="!label_block&&!required" [innerHtml]="label"></mat-label>
    <input matInput [placeholder]="placeholder || ('CLIENT.enter_mobile_number' |translate) " type="text"
      (keyup)="inputNumber($event)" (keydown)="checkForTab($event)" (focusout)="focusOutEv($event)"
      [required]="required ? true : false"
      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" [readonly]="readonly"
      [disabled]="disabled" [pattern]="'^[0-9]*$'" [formControlName]="controlName" [maxLength]="maxLength">
    <button class="btn btn-sm js-btn-save-outline ml-1" style="margin-top: -5px;"
      *ngIf="!readonly && !disabled && disabled" matSuffix (click)="triggerEvent()">
      <i class="fa fa-phone"></i>
    </button>
    <button class="btn btn-sm js-btn-save-outline ml-1" style="margin-top: -5px;"
      *ngIf="extra_controls_list && extra_controls_list.length" matSuffix (click)="showList()">
      <i class="fa {{show_list?'fa-angle-up' : 'fa-angle-down'}}  " aria-hidden="true"></i>
    </button>
    <button class="btn btn-sm js-btn-save-outline ml-1" style="margin-top: -5px;"
      *ngIf="!readonly && !disabled && enable_whats_app_url" matSuffix (click)="navigateToWhatsApp()">
      <i class="fa  fa-whatsapp"></i>
    </button>
    <button [matTooltip]="form.get(wa_control_name).value?'Right click to open WhatsApp':'Make WhatsApp number'"
      class="btn btn-sm  {{ form&& form.get(wa_control_name) &&form.get(wa_control_name).value ? 'js-btn-success':'js-btn-save-outline'}}  ml-1"
      style="margin-top: -5px;" *ngIf="!readonly && !disabled && wa_control_name" matSuffix
      (click)="toggleWa(wa_control_name) " (contextmenu)="form.get(wa_control_name).value ?navigateToWhatsApp():''">
      <i class="fa  fa-whatsapp"></i>
      <i class="fa fa-2x fa-ban " *ngIf="!form.get(wa_control_name).value" style="color: Tomato;
      position: absolute;
      z-index: 9;
      right: 3px;
      margin-top: -4px;"></i>
      <!-- <i class="fa fa-close"  ></i> -->
    </button>

    <!-- <input [required]="required" matInput [placeholder]="placeholder" type="text" [id]="id" [style]="style"
      [formControl]="new_formControl" [readonly]="disabled ? true : false" (keyup)="displayPhoneNumber($event);"
      (keydown)="inputNumber($event)" (keydown)="displayPhoneNumber($event);" [maxlength]="maxLength"> -->

    <mat-error *ngIf="form.get([controlName]).hasError('required');else maxlength">
      Field is mandatory
      <!-- <span [innerHTML]="label + ' is mandatory'"></span> -->
    </mat-error>
    <ng-template #maxlength>
      <mat-error *ngIf="form.get([controlName]).hasError('maxlength');else minlength">
        Maximum length ({{maxLength}}) has exceeded
      </mat-error>
    </ng-template>
    <ng-template #minlength>
      <mat-error *ngIf="form.get([controlName]).hasError('minlength'); else pattern">
        Minimum length must be ({{minLength}})
      </mat-error>
    </ng-template>
    <!-- <ng-template #maxvalue>
      <mat-error *ngIf="form.get([controlName]).hasError('max');else minvalue">
        Value must be lesser than {{maxValue}}
      </mat-error>
    </ng-template>
    <ng-template #minvalue>
      <mat-error *ngIf="form.get([controlName]).hasError('min'); else pattern">
        Value must be greater than {{minValue}}
      </mat-error>
    </ng-template> -->
    <ng-template #pattern>
      <mat-error *ngIf="form.get([controlName]).hasError('pattern')">
        {{'Invalid input'}}
      </mat-error>
    </ng-template>

  </mat-form-field>

  <div #options_list_view
    style="z-index:1001;opacity: 1; pointer-events: auto;color: black;position:fixed;background-color: white;top: 45px;"
    [style.width.px]="container_width" *ngIf="show_list " itemSize="40" class="viewport select-menu tm-select-menu"
    [style.left.px]="left" [style.top.px]="top">
    <div class="row m-0">
      <div class="col-md-12" *ngFor="let item of extra_controls_list">
        <div class="prefix-control" style="width: 40%;">
          <tm-select [options]="options||[]" [form_group]="form" [form_control]="item.dropdown_form_control"
            [title_property]="option_title_property" [id_property]="option_property" float_label="always"
            [label]="item.label" [data]="form.get([item.dropdown_form_control]).value"
            [placeholder]=" item.dropdown_placeholder || '< - -Select- ->'|translate " [label_overflow]="1">
          </tm-select>
        </div>
        <div class="main-control" style="width: 60%;">
          <app-phone-number [placeholder]="  item.placeholder" [options]="options"
            [options_data]="form.get([item.dropdown_form_control]).value" [form]="form"
            [controlName]="item.form_control" [data]="this.form.get([item.form_control]).value"
            [pattern_desc]="'^[0-9]*$'" [hide_label]="1" [wa_control_name]="item.wa_control_name" [func]="func ">
          </app-phone-number>
        </div>
      </div>
    </div>

  </div>

  <div id="overlay_mat_select_search" (click)="hideList()" *ngIf="display_overlay"
    style="position: fixed;width: 100%;height: 100%;z-index: 1000;left: 0;top: 0;">
  </div>
</form>
